var _g, _g2, _g3, _g4, _g5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBookshelf(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 140 250",
    shapeRendering: "crispEdges",
    id: "svg--bookshelf",
    className: "svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "bookshelf__bookshelf"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "pixel--dark-leather",
    points: "0,0 140,0 140,250 0,250"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "pixel--bookshelf-back",
    points: "10,10 130,10 130,60 10,60"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "pixel--bookshelf-back",
    points: "10,70 130,70 130,120 10,120"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "pixel--bookshelf-back",
    points: "10,130 130,130 130,180 10,180"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "pixel--bookshelf-back",
    points: "10,190 130,190 130,240 10,240"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "bookshelf__row-1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "pixel--dark-green",
    points: "10,60 20,60 20,20 10,20"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "pixel--teal",
    points: "20,30 30,30 30,60 20,60"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "pixel--denim",
    points: "30,20 50,20 50,60 30,60"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "pixel--violet",
    points: "50,20 60,20 60,60 50,60"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "pixel--gray",
    points: "60,20 70,20 70,60 60,60"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "pixel--orange",
    points: "70,30 80,30 80,60 70,60"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "pixel--cream",
    points: "80,30 100,30 100,60 80,60"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "pixel--dark-red",
    points: "100,20 110,20 110,60 100,60"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "pixel--denim",
    points: "110,20 120,20 120,60 110,60"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "pixel--teal",
    points: "120,20 130,20 130,60 120,60"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "bookshelf__row-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "pixel--violet",
    points: "10,80 20,80 20,120 10,120"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "pixel--orange",
    points: "20,90 40,90 40,120 20,120"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "pixel--cream",
    points: "40,80 50,80 50,120 40,120"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "pixel--denim",
    points: "50,90 70,90 70,120 50,120"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "pixel--dark-green",
    points: "70,120 90,120 90,80 70,80"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "pixel--teal",
    points: "90,80 100,80 100,120 90,120"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "pixel--gray",
    points: "100,90 120,90 120,120 100,120"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "pixel--dark-red",
    points: "120,90 130,90 130,120 120,120"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    className: "bookshelf__row-3"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "pixel--dark-red",
    points: "10,140 20,140 20,180 10,180"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "pixel--denim",
    points: "20,140 40,140 40,180 20,180"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "pixel--gray",
    points: "40,150 50,150 50,180 40,180"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "pixel--teal",
    points: "50,140 70,140 70,180 50,180"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "pixel--violet",
    points: "70,150 80,150 80,180 70,180"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "pixel--denim",
    points: "80,140 90,140 90,180 80,180"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "pixel--cream",
    points: "90,150 100,150 100,180 90,180"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "pixel--dark-green",
    points: "120,180 100,180 100,140 120,140"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    className: "bookshelf__row-4"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "pixel--cream",
    points: "10,200 30,200 30,240 10,240"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "pixel--dark-green",
    points: "30,240 40,240 40,200 30,200"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "pixel--dark-red",
    points: "40,210 60,210 60,240 40,240"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "pixel--gray",
    points: "60,200 80,200 80,240 60,240"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "pixel--teal",
    points: "80,200 90,200 90,240 80,240"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "pixel--violet",
    points: "90,210 110,210 110,240 90,240"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "pixel--orange",
    points: "110,200 120,200 120,240 110,240"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "pixel--denim",
    points: "120,200 130,200 130,240 120,240"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookshelf);
export default __webpack_public_path__ + "static/media/bookshelf.2bcc43de43c2dbff008009a52afc43d3.svg";
export { ForwardRef as ReactComponent };